import { ColorVariantEnum } from '@flowwai-frontend/design-system'
import {
   ActionType,
   ColorEnum,
   LayoutTabTaskStatus,
   PipelineStageTransitionUiStyle
} from '@flowwai-frontend/bps-officer-web/graphql'
import {
   ColorVariantsEnum,
   EntityActionType,
   PipelineStageTransitionStyleEnum
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { LayoutTabTaskStatusEnum } from '../constants/CRMItemConstants'

export const getConvertedColorEnum = (
   color: ColorEnum | undefined | null
): ColorVariantsEnum | null => {
   if (!color) return null

   switch (color) {
      case ColorEnum.Blue:
         return ColorVariantsEnum.Blue
      case ColorEnum.BlueDark:
         return ColorVariantsEnum.BlueDark
      case ColorEnum.BlueLight:
         return ColorVariantsEnum.BlueLight
      case ColorEnum.Cyan:
         return ColorVariantsEnum.Cyan
      case ColorEnum.Fuchsia:
         return ColorVariantsEnum.Fuchsia
      case ColorEnum.Green:
         return ColorVariantsEnum.Green
      case ColorEnum.GreenLight:
         return ColorVariantsEnum.GreenLight
      case ColorEnum.Indigo:
         return ColorVariantsEnum.Indigo
      case ColorEnum.Moss:
         return ColorVariantsEnum.Moss
      case ColorEnum.Orange:
         return ColorVariantsEnum.Orange
      case ColorEnum.OrangeDark:
         return ColorVariantsEnum.OrangeDark
      case ColorEnum.Pink:
         return ColorVariantsEnum.Pink
      case ColorEnum.Purple:
         return ColorVariantsEnum.Purple
      case ColorEnum.Rose:
         return ColorVariantsEnum.Rose
      case ColorEnum.Teal:
         return ColorVariantsEnum.Teal
      case ColorEnum.Violet:
         return ColorVariantsEnum.Violet
      case ColorEnum.Yellow:
         return ColorVariantsEnum.Yellow
   }
}

export const convertColorVariantEnumToColorEnum = (
   color: ColorVariantsEnum | undefined | null
): ColorEnum | null => {
   if (!color) return null

   switch (color) {
      case ColorVariantsEnum.Blue:
         return ColorEnum.Blue
      case ColorVariantsEnum.BlueDark:
         return ColorEnum.BlueDark
      case ColorVariantsEnum.BlueLight:
         return ColorEnum.BlueLight
      case ColorVariantsEnum.Cyan:
         return ColorEnum.Cyan
      case ColorVariantsEnum.Fuchsia:
         return ColorEnum.Fuchsia
      case ColorVariantsEnum.Green:
         return ColorEnum.Green
      case ColorVariantsEnum.GreenLight:
         return ColorEnum.GreenLight
      case ColorVariantsEnum.Indigo:
         return ColorEnum.Indigo
      case ColorVariantsEnum.Moss:
         return ColorEnum.Moss
      case ColorVariantsEnum.Orange:
         return ColorEnum.Orange
      case ColorVariantsEnum.OrangeDark:
         return ColorEnum.OrangeDark
      case ColorVariantsEnum.Pink:
         return ColorEnum.Pink
      case ColorVariantsEnum.Purple:
         return ColorEnum.Purple
      case ColorVariantsEnum.Rose:
         return ColorEnum.Rose
      case ColorVariantsEnum.Teal:
         return ColorEnum.Teal
      case ColorVariantsEnum.Violet:
         return ColorEnum.Violet
      case ColorVariantsEnum.Yellow:
         return ColorEnum.Yellow
      default:
         return null
   }
}

export const convertColorVariantEnumToGraphqlColorEnum = (
   color: ColorVariantEnum
): ColorEnum => {
   switch (color) {
      case 'BLUE':
         return ColorEnum.Blue
      case 'BLUE_DARK':
         return ColorEnum.BlueDark
      case 'BLUE_LIGHT':
         return ColorEnum.BlueLight
      case 'CYAN':
         return ColorEnum.Cyan
      case 'FUCHSIA':
         return ColorEnum.Fuchsia
      case 'GREEN':
         return ColorEnum.Green
      case 'GREEN_LIGHT':
         return ColorEnum.GreenLight
      case 'INDIGO':
         return ColorEnum.Indigo
      case 'MOSS':
         return ColorEnum.Moss
      case 'ORANGE':
         return ColorEnum.Orange
      case 'ORANGE_DARK':
         return ColorEnum.OrangeDark
      case 'PINK':
         return ColorEnum.Pink
      case 'PURPLE':
         return ColorEnum.Purple
      case 'ROSE':
         return ColorEnum.Rose
      case 'TEAL':
         return ColorEnum.Teal
      case 'VIOLET':
         return ColorEnum.Violet
      case 'YELLOW':
         return ColorEnum.Yellow
      default:
         throw new Error('Invalid Color')
   }
}

export const convertColorEnumToColorVariantEnum = (
   color: ColorEnum
): ColorVariantEnum => {
   switch (color) {
      case ColorEnum.Blue:
         return 'BLUE'
      case ColorEnum.BlueDark:
         return 'BLUE_DARK'
      case ColorEnum.BlueLight:
         return 'BLUE_LIGHT'
      case ColorEnum.Cyan:
         return 'CYAN'
      case ColorEnum.Fuchsia:
         return 'FUCHSIA'
      case ColorEnum.Green:
         return 'GREEN'
      case ColorEnum.GreenLight:
         return 'GREEN_LIGHT'
      case ColorEnum.Indigo:
         return 'INDIGO'
      case ColorEnum.Moss:
         return 'MOSS'
      case ColorEnum.Orange:
         return 'ORANGE'
      case ColorEnum.OrangeDark:
         return 'ORANGE_DARK'
      case ColorEnum.Pink:
         return 'PINK'
      case ColorEnum.Purple:
         return 'PURPLE'
      case ColorEnum.Rose:
         return 'ROSE'
      case ColorEnum.Teal:
         return 'TEAL'
      case ColorEnum.Violet:
         return 'VIOLET'
      case ColorEnum.Yellow:
         return 'YELLOW'
   }
}

export const convertGqlStageTransitionStyleToPipelineStageTransitionStyle = (
   gqlStageTransitionStyle: PipelineStageTransitionUiStyle
): PipelineStageTransitionStyleEnum => {
   switch (gqlStageTransitionStyle) {
      case PipelineStageTransitionUiStyle.Buttons: {
         return PipelineStageTransitionStyleEnum.Buttons
      }
      case PipelineStageTransitionUiStyle.Dropdown: {
         return PipelineStageTransitionStyleEnum.Dropdown
      }

      default: {
         throw new Error(`${gqlStageTransitionStyle} - not found`)
      }
   }
}

export const convertPipelineStageTransitionStyleToGqlStageTransitionStyle = (
   stageTransitionStyle: PipelineStageTransitionStyleEnum
): PipelineStageTransitionUiStyle => {
   switch (stageTransitionStyle) {
      case PipelineStageTransitionStyleEnum.Buttons: {
         return PipelineStageTransitionUiStyle.Buttons
      }
      case PipelineStageTransitionStyleEnum.Dropdown: {
         return PipelineStageTransitionUiStyle.Dropdown
      }

      default: {
         throw new Error(`${stageTransitionStyle} - not found`)
      }
   }
}

export const convertLayoutTabTaskStatusEnumToLayoutTabTaskStatus = (
   taskStatus: LayoutTabTaskStatusEnum
): LayoutTabTaskStatus => {
   switch (taskStatus) {
      case LayoutTabTaskStatusEnum.Accepted:
         return LayoutTabTaskStatus.Accepted
      case LayoutTabTaskStatusEnum.NotStarted:
         return LayoutTabTaskStatus.NotStarted
      case LayoutTabTaskStatusEnum.OverallRemarksNotFilled:
         return LayoutTabTaskStatus.OverallRemarksNotFilled
      case LayoutTabTaskStatusEnum.Rejected:
         return LayoutTabTaskStatus.Rejected
      case LayoutTabTaskStatusEnum.RequiredFieldsNotFilled:
         return LayoutTabTaskStatus.RequiredFieldsNotFilled
      case LayoutTabTaskStatusEnum.Shortfall:
         return LayoutTabTaskStatus.Shortfall
      case LayoutTabTaskStatusEnum.FieldRemarksNotFilled:
         return LayoutTabTaskStatus.FieldRemarksNotFilled
      case LayoutTabTaskStatusEnum.Discarded:
         return LayoutTabTaskStatus.Discarded
      default:
         throw new Error(
            `Unexpected taskStatus: ${taskStatus} in convertLayoutTabTaskStatusEnumToLayoutTabTaskStatus`
         )
   }
}

export const convertLayoutTabTaskStatusToLayoutTabTaskStatusEnum = (
   taskStatus: LayoutTabTaskStatus
): LayoutTabTaskStatusEnum => {
   switch (taskStatus) {
      case LayoutTabTaskStatus.Accepted:
         return LayoutTabTaskStatusEnum.Accepted
      case LayoutTabTaskStatus.NotStarted:
         return LayoutTabTaskStatusEnum.NotStarted
      case LayoutTabTaskStatus.OverallRemarksNotFilled:
         return LayoutTabTaskStatusEnum.OverallRemarksNotFilled
      case LayoutTabTaskStatus.Rejected:
         return LayoutTabTaskStatusEnum.Rejected
      case LayoutTabTaskStatus.RequiredFieldsNotFilled:
         return LayoutTabTaskStatusEnum.RequiredFieldsNotFilled
      case LayoutTabTaskStatus.Shortfall:
         return LayoutTabTaskStatusEnum.Shortfall
      case LayoutTabTaskStatus.FieldRemarksNotFilled:
         return LayoutTabTaskStatusEnum.FieldRemarksNotFilled
      case LayoutTabTaskStatus.Discarded:
         return LayoutTabTaskStatusEnum.Discarded
      default:
         throw new Error(
            `Unexpected taskStatus: ${taskStatus} in convertLayoutTabTaskStatusToLayoutTabTaskStatusEnum`
         )
   }
}

export const convertGqlActionTypeToLocalActionType = (
   actionType: ActionType
): EntityActionType => {
   switch (actionType) {
      case ActionType.Hide:
         return 'HIDE'
      case ActionType.MakeRequired:
         return 'MAKE_REQUIRED'
      case ActionType.Reconciliation:
         return 'RECONCILIATION'
      case ActionType.Validate:
         return 'VALIDATE'
      case ActionType.Show:
         return 'SHOW'
      default:
         throw new Error(
            `Unexpected actionType: ${actionType} in convertGqlActionTypeToLocalActionType`
         )
   }
}
